import type {
  CtAttributionSegment,
  CtCallRow,
  CtMetrics,
  CtNumberRow,
  CtStat,
} from './types';

export const CT_METRICS: CtMetrics = {
  totalCalls: 247,
  booked: 89,
  bookedRate: 36,
  avgCallDuration: '3m 42s',
  callbacks: 42,
};

export const CT_STATS: CtStat[] = [
  {
    key: 'total',
    label: 'Total Ad Calls',
    value: '247',
    sub: 'Last 30 days',
    tone: 'neutral',
  },
  {
    key: 'booked',
    label: 'Booked from Calls',
    value: '89',
    suffix: '36%',
    sub: 'Confirmed via PMS match',
    tone: 'success',
  },
  {
    key: 'callbacks',
    label: 'Pending Callbacks',
    value: '42',
    sub: 'Awaiting follow-up',
    link: 'View in Human-in-Loop',
    tone: 'gold',
  },
  {
    key: 'duration',
    label: 'Avg Call Duration',
    value: '3m 42s',
    sub: 'Across all ad calls',
    tone: 'neutral',
  },
];

export const CT_ATTRIBUTION: CtAttributionSegment[] = [
  { key: 'ad_click_to_call', label: 'Click-to-Call (mobile ads)', value: 104, tone: 'terra' },
  { key: 'landing_page_ads', label: 'Landing Page (Google Ads)', value: 132, tone: 'info' },
  { key: 'landing_page_sms', label: 'Landing Page (SMS/Email)', value: 11, tone: 'iris' },
];

export const CT_NUMBER_POOL: CtNumberRow[] = [
  { number: '(212) 555-0141', status: 'assigned', assignedTo: 'Emergency Dental — Same Day', source: 'ad_click_to_call', assignedDate: '2 months ago', callsThisMonth: 62 },
  { number: '(212) 555-0142', status: 'assigned', assignedTo: 'Emergency Dental — Same Day', source: 'landing_page_ads', assignedDate: '2 months ago', callsThisMonth: 28 },
  { number: '(212) 555-0143', status: 'assigned', assignedTo: 'Dental Implants — All-on-4', source: 'landing_page_ads', assignedDate: '6 weeks ago', callsThisMonth: 19 },
  { number: '(212) 555-0144', status: 'assigned', assignedTo: 'Invisalign — Adults 25-45', source: 'landing_page_ads', assignedDate: '6 weeks ago', callsThisMonth: 14 },
  { number: '(212) 555-0145', status: 'assigned', assignedTo: 'Teeth Whitening — Spring', source: 'landing_page_ads', assignedDate: '3 weeks ago', callsThisMonth: 11 },
  { number: '(212) 555-0146', status: 'assigned', assignedTo: 'Family Dentist — Near Me', source: 'landing_page_ads', assignedDate: '5 weeks ago', callsThisMonth: 18 },
  { number: '(212) 555-0147', status: 'assigned', assignedTo: 'Weekend Emergency Walk-In', source: 'ad_click_to_call', assignedDate: '4 months ago', callsThisMonth: 42 },
  { number: '(212) 555-0148', status: 'assigned', assignedTo: 'Cosmetic Veneers — Premium', source: 'landing_page_ads', assignedDate: '2 weeks ago', callsThisMonth: 6 },
  { number: '(212) 555-0149', status: 'assigned', assignedTo: 'SMS & Email campaigns (shared)', source: 'landing_page_sms', assignedDate: '3 months ago', callsThisMonth: 8 },
  { number: '(212) 555-0150', status: 'reserved', assignedTo: 'Sedation Dentistry (paused)', source: 'landing_page_ads', assignedDate: '2 weeks ago', callsThisMonth: 0, reservedUntil: 'in 16 days' },
];

export const CT_CALLS: CtCallRow[] = [
  { id: 1, caller: '(917) 555-0198', callerName: 'Jessica M.', time: 'Today · 2:14 PM', duration: '4m 12s', source: 'ad_click_to_call', campaign: 'Emergency Dental — Same Day', number: '(212) 555-0141', outcome: 'booked', handoff: 'ai_closed', intent: 'Emergency Pain' },
  { id: 2, caller: '(646) 555-0121', callerName: 'Robert K.', time: 'Today · 1:47 PM', duration: '6m 38s', source: 'landing_page_ads', campaign: 'Dental Implants — All-on-4', number: '(212) 555-0143', outcome: 'callback', handoff: 'warm_transfer', intent: 'Implant Consultation' },
  { id: 3, caller: '(929) 555-0043', callerName: 'Sarah L.', time: 'Today · 12:33 PM', duration: '2m 51s', source: 'landing_page_ads', campaign: 'Invisalign — Adults 25-45', number: '(212) 555-0144', outcome: 'booked', handoff: 'ai_closed', intent: 'New Patient' },
  { id: 4, caller: '(347) 555-0077', callerName: 'Unknown', time: 'Today · 11:58 AM', duration: '0m 42s', source: 'ad_click_to_call', campaign: 'Emergency Dental — Same Day', number: '(212) 555-0141', outcome: 'spam', handoff: 'abandoned', intent: 'Unclear' },
  { id: 5, caller: '(718) 555-0314', callerName: 'David C.', time: 'Today · 10:22 AM', duration: '3m 14s', source: 'landing_page_ads', campaign: 'Family Dentist — Near Me', number: '(212) 555-0146', outcome: 'booked', handoff: 'ai_closed', intent: 'New Patient' },
  { id: 6, caller: '(212) 555-0891', callerName: 'Maria G.', time: 'Yesterday · 4:45 PM', duration: '5m 03s', source: 'landing_page_ads', campaign: 'Weekend Emergency Walk-In', number: '(212) 555-0147', outcome: 'booked', handoff: 'warm_transfer', intent: 'Emergency Pain' },
  { id: 7, caller: '(917) 555-0412', callerName: 'James P.', time: 'Yesterday · 3:21 PM', duration: '1m 48s', source: 'landing_page_ads', campaign: 'Teeth Whitening — Spring', number: '(212) 555-0145', outcome: 'info_only', handoff: 'ai_closed', intent: 'Pricing Question' },
  { id: 8, caller: '(646) 555-0734', callerName: 'Lisa N.', time: 'Yesterday · 2:02 PM', duration: '4m 27s', source: 'landing_page_ads', campaign: 'Cosmetic Veneers — Premium', number: '(212) 555-0148', outcome: 'callback', handoff: 'warm_transfer', intent: 'Veneers Consultation' },
  { id: 9, caller: '(929) 555-0623', callerName: 'Tom R.', time: 'Yesterday · 12:15 PM', duration: '0m 18s', source: 'ad_click_to_call', campaign: 'Weekend Emergency Walk-In', number: '(212) 555-0147', outcome: 'spam', handoff: 'no_answer', intent: 'Unclear' },
  { id: 10, caller: '(347) 555-0299', callerName: 'Patricia S.', time: 'Yesterday · 11:08 AM', duration: '3m 52s', source: 'landing_page_sms', campaign: 'End-of-Year Benefits (SMS)', number: '(212) 555-0149', outcome: 'booked', handoff: 'ai_closed', intent: 'Reactivation' },
];

export const CT_POOL_NOTE =
  "ELVA automatically assigns and manages these numbers. When a campaign pauses, its number is held for 30 days before being released back to the pool. Don't use these numbers in offline materials (business cards, flyers) — they're tied to specific campaigns.";
